import {
  TE_STATE_CANCELLED,
  TE_STATE_FINALIZED,
  TE_STATE_PAUSED,
  TE_STATE_STARTED,
} from "./coachExerciseNavigation";
import { isRealKotMatchId } from "./kotCoachSubmit";
import { findKotMatchAtTable, findMyKotMatch } from "./trainingRoomAccess";

function matchState(match) {
  return String(match?.match_state || match?.matchStatus || "")
    .trim()
    .toUpperCase();
}

function resolveKotMatchRow({
  snapshot,
  viewerPlayerId,
  tableNumber,
  tablePhone,
}) {
  if (tablePhone && tableNumber != null && tableNumber !== "") {
    return findKotMatchAtTable(snapshot, tableNumber);
  }
  return findMyKotMatch(snapshot, viewerPlayerId);
}

/**
 * Live KoT match this device should record (full match, not eval-window).
 * Player phones follow the viewer's match; table cameras stay on their table
 * even as players rotate through King of the Table.
 */
export function resolveKotMatchRecordingTarget({
  snapshot = null,
  viewerPlayerId = null,
  exerciseStateId = null,
  tableNumber = null,
  tablePhone = false,
} = {}) {
  if (
    exerciseStateId === TE_STATE_PAUSED ||
    exerciseStateId === TE_STATE_FINALIZED ||
    exerciseStateId === TE_STATE_CANCELLED
  ) {
    return null;
  }
  if (exerciseStateId != null && exerciseStateId !== TE_STATE_STARTED) {
    return null;
  }
  const match = resolveKotMatchRow({
    snapshot,
    viewerPlayerId,
    tableNumber,
    tablePhone,
  });
  const kotMatchId = match?.kot_match_id || match?.matchId || null;
  if (!isRealKotMatchId(kotMatchId)) return null;
  if (matchState(match) !== "IN_PROGRESS") return null;
  const id = String(kotMatchId).trim();
  return {
    kotMatchId: id,
    clipKey: `kot:${id}`,
    match,
    tableNumber:
      match?.table_number != null ? Number(match.table_number) : tableNumber,
  };
}

/** Warm the camera for the round so the first seconds of the match are not blank. */
export function shouldPrewarmKotMatchCamera({
  snapshot = null,
  viewerPlayerId = null,
  exerciseStateId = null,
  tableNumber = null,
  tablePhone = false,
} = {}) {
  if (
    resolveKotMatchRecordingTarget({
      snapshot,
      viewerPlayerId,
      exerciseStateId,
      tableNumber,
      tablePhone,
    })
  ) {
    return true;
  }
  if (exerciseStateId !== TE_STATE_STARTED) return false;
  const round = String(snapshot?.current_round?.round_state || "").toUpperCase();
  if (round !== "IN_PROGRESS" && round !== "STOP_REQUESTED") return false;
  const match = resolveKotMatchRow({
    snapshot,
    viewerPlayerId,
    tableNumber,
    tablePhone,
  });
  if (!match) return false;
  const state = matchState(match);
  return state === "IN_PROGRESS" || state === "SCHEDULED";
}

export function kotMatchIdFromClipKey(clipKey) {
  const raw = String(clipKey || "");
  if (!raw.startsWith("kot:")) return null;
  const id = raw.slice(4).trim();
  return isRealKotMatchId(id) ? id : null;
}
